import PropTypes from 'prop-types'

import { Input } from 'antd'

import { CalendarOutlined } from '@ant-design/icons'

import { getTotalDaysInMonthBS } from './helper'

// import Calendar from './Calendar'

/**
 * custom DatePicker field
 * @param {*} props
 * @returns
 */
export default function DateField(props) {
  const { onChange, value: defaultValue } = props

  const taggerChange = (event) => {
    let value = event.target.value
    if (!/^\d{0,4}-?\d{0,2}-?\d{0,2}$/.test(value)) {
      return
    }

    // // Ensure format yyyy-mm-dd while typing
    if (value.length === 4 && !value.includes('-')) {
      value = value + '-'
    } else if (value.length === 7 && value.split('-').length === 2) {
      value = value + '-'
    }

    const [year, month, day] = value.split('-')

    if (!isNaN(month) && month > 12) {
      return
    }

    if (!isNaN(day) && day > getTotalDaysInMonthBS(year, month)) {
      return
    }

    onChange(value)
  }

  return (
    // <Popover content={<Calendar />} trigger="click">
    <Input
      type="text"
      className="flex items-center"
      addonBefore={<CalendarOutlined />}
      onChange={taggerChange}
      value={defaultValue}
      placeholder="YYYY-mm-dd"
      disabled={props?.disabled}
    // prefix={<CalendarOutlined />}
    />
    // </Popover>
  )
}

DateField.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
}
